import React from 'react'
import { Box, Button } from '@mui/material'
import { useLang } from '~/hooks/useLang';
import { type State } from '@hookstate/core';
import type { DisabledNextButton, WorkScheduleFormSteps } from '../../interfaces';

interface StepActionsProps {
  readonly index: number;
  readonly disabledNextButton: State<DisabledNextButton>;
  readonly steps: ReadonlyArray<WorkScheduleFormSteps>;
  readonly isEditMode?: boolean;
  readonly handleNext: () => void;
  readonly handleBack: () => void;
}

const STEP_VALIDATION_MAP: Record<number, keyof DisabledNextButton> = {
  0: 'disabledWorkShift',
  1: 'disabledDevice',
  2: 'disabledCrew'
} as const;

export default function StepActions({ handleNext, handleBack, index, steps, disabledNextButton, isEditMode }: StepActionsProps) {
  const { translate } = useLang();
  const isLastStep = index === steps.length - 1;
  const isFirstStep = index === 0;

  const isNextButtonDisabled = (): boolean => {
    const validationKey = STEP_VALIDATION_MAP[index];
    return validationKey ? disabledNextButton.get()[validationKey] : false;
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Button
        disabled={isFirstStep || isEditMode}
        onClick={handleBack}
        sx={{ mt: 1, mr: 1 }}
      >
        {translate('Back')}
      </Button>
      <Button
        variant="contained"
        disabled={isNextButtonDisabled()}
        onClick={handleNext}
        sx={{ mt: 1, mr: 1 }}
      >
        {translate(isLastStep ? 'Finish' : 'Continue')}
      </Button>
    </Box>
  )
}